import React, {useEffect} from 'react';
import {useAppDispatch} from "../../hooks/redux";
import {appSlice} from "../../store/reducers/AppSlice";
import {TransactionType} from "../../model/TransactionType";

const TransferTransactionsPage = () => {
    const dispatch = useAppDispatch();
    const {setTitle, setTrType} = appSlice.actions;

    useEffect(() => {
        dispatch(setTitle('Transfer Transactions'));
        dispatch(setTrType(TransactionType.Transfer));
    });

    return (
        <div>

        </div>
    );
};

export default TransferTransactionsPage;